export default __webpack_public_path__ + "media/images/banners/months/bnr_10-1cca0045bae018a16964efa651240289.jpg";